import { render, staticRenderFns } from "./case-import-list.vue?vue&type=template&id=2ed8a262&scoped=true"
import script from "./case-import-list.vue?vue&type=script&lang=ts"
export * from "./case-import-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed8a262",
  null
  
)

export default component.exports